<template>
  <div class="company__table">
    <table class="company__table-company">
      <tbody>
        <tr>
          <th style="width: 212px;">{{ $t("common.companyName") }}</th>
          <th style="width: 81px;">
            {{ $t("event.changeCompany.modal.companyProfile") }}
          </th>
          <th style="width: 83px;">
            {{ $t("event.changeCompany.modal.catalogApplication") }}
          </th>
          <th style="width: 111px;">
            {{ $t("event.changeCompany.modal.participantPasses") }}
          </th>
          <th style="width: 100px;">
            {{ $t("event.changeCompany.modal.carPasses") }}
          </th>
          <th style="width: 61px;"></th>
        </tr>

        <tr v-for="company in companies" :key="company.id">
          <td>
            <span
              :class="{ 'company__table-td-blue': event.id === company.id }"
            >
              {{
                locale === "ru"
                  ? company.company.name_rus
                  : company.company.name_eng || company.company.name_rus
              }}
            </span>
          </td>
          <td>
            <DotText
              :class="{
                _warning: !hasCompleteCompany,
                _success: hasCompleteCompany
              }"
            />
          </td>
          <td>
            <DotText
              :class="{
                _warning: company.catalog_order_status === 'draft',
                _success: company.catalog_order_status !== 'draft'
              }"
            />
          </td>
          <td>
            <span class="company__table-company-value">
              {{ company.quota?.certificate_count || 0 }}
              {{ locale === "en" ? "out of" : "из" }}
              {{ company.quota?.certificate || 0 }}
            </span>
          </td>
          <td style="padding-left: 8px">
            <span class="company__table-company-value">
              {{ company.car_passes_count }}
            </span>
          </td>
          <td>
            <button
              class="company__table-company-button"
              type="button"
              v-if="event.id !== company.id"
              @click="choseCompany(company.id)"
            >
              {{ $t("common.selectBtn") }}
            </button>
          </td>
        </tr>
      </tbody>
    </table>
  </div>
</template>

<script>
import { DotText } from "@v2/shared/ui/components";
import { i18n } from "@v2/shared/config";
import { mapState, mapGetters } from "vuex";
import apiParticipant from "@/api/participant";

export default {
  components: {
    DotText
  },

  computed: {
    locale() {
      return i18n.locale;
    },

    ...mapState("event", ["event"]),
    ...mapGetters("event", ["hasCompleteCompany"])
  },

  props: ["companies"],

  methods: {
    async choseCompany(id) {
      await apiParticipant.makePrimary(id);
      window.location.replace(`/participant/${id}`);
    }
  }
};
</script>

<style lang="scss">
@import "@v2/app/styles/mixins";

.company__table {
  margin: 16px 0 0 0;
  overflow-x: auto;

  &-company {
    max-width: 780px;
    min-width: 580px;
    width: 100%;

    border-collapse: collapse;
    border-spacing: 0;

    &-title {
      @include h2();
      margin: 0 0 0 0;
      padding: 0 0 0 0;

      font-size: 16px;
      font-weight: normal;
      line-height: 1.5;

      text-decoration: none;

      &:hover {
        text-decoration: underline;
      }
    }

    &-value {
      font-size: 13px;
      line-height: 1.54;
      color: #6d7179;
    }

    &-button {
      @include underline-button;
    }

    tr th {
      color: #a3a8b3;
      font-size: 12px;
      line-height: 1.33;
      font-weight: normal;
      border-top: 1px solid rgba(205, 206, 208, 0.5);
      border-bottom: 1px solid rgba(205, 206, 208, 0.5);
      padding: 15px 10px 16px 0;
      text-align: left;
      vertical-align: top;
    }

    tr td {
      border-top: 1px solid rgba(205, 206, 208, 0.5);
      border-bottom: 1px solid rgba(205, 206, 208, 0.5);
      padding: 25px 0 26px 0;
      text-align: left;
    }
  }

  &-td-blue {
    color: #009ee3;
  }
}
</style>
